var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcXbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M661 211c11-3 23-3 34-2 28 5 54 15 78 30 34 23 61 56 76 95 46 109 69 226 68 344 1 35-10 69-31 97-9 10-21 16-35 16-13 0-26-6-35-16l-85-114c-19-25-49-40-81-40H350c-32 0-62 15-81 40l-85 114c-14 17-38 22-57 11-5-3-9-7-13-11-21-28-32-62-31-97-1-118 22-235 68-344 15-39 42-72 76-95 21-14 45-23 69-28 3-1 6-1 9-2 4 0 9-1 13-1 16 0 31 5 44 13 14 10 30 15 47 16h182c17-1 33-6 47-16 7-4 15-8 23-10zM500 318c-34 0-62 28-62 62 0 35 28 63 62 63 35 0 63-28 63-63 0-34-28-62-63-62z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcXbox);
export default __webpack_public_path__ + "static/media/ic_xbox.4e4bb3aa5ad97427a96f6ded5497548d.svg";
export { ForwardRef as ReactComponent };